module["exports"] = [
  "vermelho",
  "verde",
  "azul",
  "amarelo",
  "roxo",
  "branco",
  "preto",
  "laranja",
  "rosa",
  "cinzento",
  "castanho",
  "violeta",
  "turquesa",
  "bronzeado",
  "salmão",
  "ameixa",
  "orquídea",
  "magenta",
  "lima",
  "marfim",
  "índigo",
  "ouro",
  "fúcsia",
  "ciano",
  "azure",
  "lavanda",
  "prata"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_PT/commerce/color.js
// module id = 3450
// module chunks = 1610